import { IoIosPlay } from "react-icons/io";
import {  ButtonPrimaryOutline, TopMenu } from "../../common";
import { urlsPages } from "../../common/urls/urls-pages";
import { UrlUtils } from "../../config/utils/url-utils";
import { Action } from "./application/domain/actions";

interface Props {
    actions: Action[];
    workoutId: string;
}
export const ActionsTopMenu: React.FC<Props> = ({ actions, workoutId }) => {
    return (
        <TopMenu avatarEnabled={false}>
            <>                
                {actions?.length > 0 && (
                    <>
                        <ButtonPrimaryOutline
                            width="90px"
                            height="40px"
                            margintop="40px"
                            goToPage={UrlUtils.goToPage(urlsPages.connection, workoutId)}
                        >
                            <IoIosPlay />
                            Iniciar
                        </ButtonPrimaryOutline>
                    </>
                )}
            </>
        </TopMenu>
    );
};